export enum GlobalStyleVariables {
  OverlayLoaderZIndex = 'var(--z-index-overlay-loader)',
  PopoverContentZIndex = 'var(--z-index-popover-content)',
  FloatingContentZIndex = 'var(--z-index-floating-content)',
}
